import { cx } from 'class-variance-authority';
import React from 'react';

type FormTextareaProps = {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  defaultValue?: string;
  error?: boolean;
  className?: string;
};
const FormTextarea = React.forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ placeholder, error, className, ...rest }, ref) => {
    return (
      <textarea
        className={cx([
          'focus:outline-primary block min-h-[15rem] w-full resize-none  rounded-[1.6rem] border-[1px] border-solid border-[#D9D9D9] bg-white p-[1.6rem] leading-[1.4] text-black placeholder-gray-400 focus:bg-white focus:p-[1.4rem]',
          error ? 'outline outline-2 outline-brand-red' : 'outline-none',
          className,
        ])}
        placeholder={placeholder}
        ref={ref}
        {...rest}
      />
    );
  }
);

FormTextarea.displayName = 'FormTextarea';

export default FormTextarea;
